import styled from 'styled-components';
import Tooltip from '../../../HOC/Tooltip/Tooltip';
import { BodyRegularS, CaptionBoldL, CaptionRegularM } from '../../../styles/globals';
import { IThemeProvider, ITheme } from '../../../styles/theme';

interface IAccordionTileCont {
  theme: ITheme;
  active?: boolean;
  notAssigned?: boolean;
}
export const AccordionTileCont = styled.div<IAccordionTileCont>`
    position: relative;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    box-sizing: border-box;
    padding: 0 14px 0 56px;
    height: 48px;
    display: flex;
    align-items: center;
  ${({ theme, active, notAssigned }: IAccordionTileCont) => `
        border: solid ${theme.colors.secondary[30]};
        border-width: 1px 0 0 0;
        background: ${active && !notAssigned ? `
          linear-gradient(180deg, ${theme.colors.secondary[10]} 0%, ${theme.colors.neutral.primary[0]} 100%);
        ` : `
        ${theme.colors.neutral.primary[0]} 
        `};
        ${notAssigned ? `
          background:  ${theme.colors.neutral.primary[5]};
          border: 1px dashed ${theme.colors.neutral.primary[30]};
          border-width: 1px 0 0 0;        
          color: ${theme.colors.neutral.primary[80]};
        ` : `
        transition: all 0.2s ease;
          &:hover {
           background: linear-gradient(180deg, ${theme.colors.secondary[10]} 0%, ${theme.colors.neutral.primary[0]} 100%)}
        `}
  `}
`;

export const TileActionIconCont = styled.div`
  cursor: pointer;
  position: relative;
  width: 20px;
  height: 20px;
  display: flex;
`;

interface IAccTile {
  theme: ITheme,
  active?: boolean,
}

export const TileExpandIconCont = styled.div<IAccTile>`
  position: relative;
  cursor: pointer;
  margin: 0 17px 0 0;
  svg {
    height: 12px;
    width: 7.4px
  }
  ${({ active }: IAccTile) => `
       transition: linear 0.1s;
       transition-timing-function: cubic-bezier(.47,.13,.23,.92);
       transform: ${active ? 'rotate(90deg)' : 'translateY(2px) rotate(0deg)'};
  `}
`;


export const TileInfoArea = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
`;

export const TitleCont = styled.div`
  position: relative;
  align-items: center;
  display: flex;
  flex-wrap: nowrap;
  width: 350px;
`;

export const TitleTooltip = styled(Tooltip)`
  min-width: 0;
`;

export const TileTitle = styled(CaptionBoldL)`
  text-transform: uppercase;
  position: relative;
  user-select: none;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${({ theme }: IThemeProvider) => `
        margin: 0 ${theme.layout.spacing.centy} 0 0;
  `}
`;

export const QuestionsNo = styled(CaptionRegularM)`
      display: flex;
      align-items: center;
      ${({ theme }: IThemeProvider) => `
        color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const TileBadge = styled(CaptionRegularM)`
  display: flex;
  align-items: center;
  height: 22px;
  border-radius: 4px;
  ${({ theme }: IThemeProvider) => `
        padding: ${theme.layout.spacing.nano}  ${theme.layout.spacing.mili};
        color: ${theme.colors.neutral.primary[80]};
        border: 1px solid ${theme.colors.secondary[70]};
        margin: 0 ${theme.layout.spacing.mikro} 0 0;
        background: ${theme.colors.secondary[10]};
  `}
`;

export const BadgeCont = styled.span`
    display: flex;
`;


interface ITileBody {
  theme: ITheme;
  notAssigned?: boolean;
}

export const TileBody = styled.div<ITileBody>`
  ${({ theme, notAssigned }: ITileBody) => `
         background: ${notAssigned ? `
           ${theme.colors.neutral.primary[5]};
         ` : `${theme.colors.neutral.primary[0]}`};
        padding: 0
         ${theme.layout.spacing.peta} 
         ${theme.layout.spacing.decy} 
         ${theme.layout.spacing.tera};
        
  `}
`;

export const TileBodyText = styled(BodyRegularS)`
  display: flex;
  flex-direction: column;
  ${({ theme }: IThemeProvider) => `
        color: ${theme.colors.neutral.primary[80]};
        margin: ${theme.layout.spacing.mikro};
  `}
`;

export const TileIconCont = styled.div`
  position: relative;
  cursor: pointer;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  ${({ theme }: IThemeProvider) => `
        margin: 0 ${theme.layout.spacing.mikro} 0 0;
  `}
`;
